/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-06-22 15:57:23
 */

import enLocale from "element-ui/lib/locale/lang/en";
const en = {
  routeName: {
    home: "home",
    shiYan:"shiyan",
    pointCost: "pointCost",
    discount: "discount",
    virtualAccount: "virtualAccount",
    transferVirtual: "transferVirtual",
    checkDraftApplyPrint: "checkDraftApplyPrint",
    beReceiveInvoice: "beReceiveInvoice",
    transportEstimate: "transportEstimate",
    needPayTax: "needPayTax",
    closingAcount: "closingAcount",
    myReceiveAndPay: "myReceiveAndPay",
    curstomerNeedReceive: "curstomerNeedReceive",
    transportNeedPay: "transportNeedPay",
    supplyNeedPay: "supplyNeedPay",
    transportStand: "transportStand",
    purchaseStand: "purchaseStand",
    sellStand: "sellStand",
    purchaseEstimate: "purchaseEstimate",
    sellEstimate: "sellEstimate",
    purchaseReport: "purchaseReport",
    transportReport: "transportReport",
    sellReport: "sellReport",
    fundConfig: "fundConfig",
    baseConfig: "baseConfig",
    transferUnit: "transferUnit",
    transferAccount: "transferAccount",
    cylindermanage:"cylindermanage",
    subject: "subject",
    invoiceMag: "invoiceMag",
    invoiceNew: "invoiceNew",
    invoiceApply: "invoiceApply",
    fundMag: "fundMag",
    profitability:"profitability",
    fixedAssets:"fixedAssets",
    ratioAnalysis:"ratioAnalysis",
    manageRate:"manageRate",
    benefitsList:"benefitsList",
    projectBenefits:"projectBenefits",
    tools: "tools",
    LNGProposal: "LNGProposal",
    transferOrder: "transferOrder",
    payApproveOrder: "payApproveOrder",
    relateSearch: "relateSearch",
    accountBalance: "accountBalance",
    receiveMoney: "receiveMoney",
    payMoney: "payMoney",
    circleStartBalance: "circleStartBalance",
    draft: "draft",
    draftCollect: "draftCollect",
    performance: "performance",
    personPointDetail: "personPointDetail",
    performanceRank: "performanceRank",
    performIndex:"performIndex",
    performRule:"performRule",
    workOrder:"workOrder",
    decutePointRule: "decutePointRule",
    examItemList: "examItemList",
    appVersion: "appVersion",
    settlement: "settlement",
    transport: "transport",
    closingAccounts: "closingAccounts",
    executionClause: "executionClause",
    invoice: "invoice",
    newinvoice: "newinvoice",
    beinvoice: "beinvoice",
    companyPolicy: "companyPolicy",
    metering: "metering",
    otherExpenses: "otherExpenses",
    receivableList:"receivableList",
    mySettlement: "mySettlement",
    unusualMetering: "unusualMetering",
    innerCash:"innerCash",
    purchasePrice:"purchasePrice",
    groupPurchase:"groupPurchase",
    innerPrice:"innerPrice",
    innerForm:"innerForm",
    compareForm:"compareForm",
    fixedTrack:"fixedTrack",
    reject:"reject",
    standardFreightList:"standardFreightList",
    innerPriceHistoryList:'innerPriceHistoryList',
    lCngChargeList:'lCngChargeList',
    purchasePriceAnalysis: "purchasePriceAnalysis",
    myPurchase:"myPurchase",
    mypurchasel:"mypurchasel",
    subcompanyPlan:"subcompanyPlan",
    arrangePurchasingPlan:"arrangePurchasingPlan",
    batchConfirm:"batchConfirm",
    preferentialClauseList:"preferentialClauseList",
    priceConfirmList:"priceConfirmList",
    purchaseList:"purchaseList",
    changeSettleAmountList:"changeSettleAmountList",
    purchasePlanH:"purchasePlanH",
    newPlan:"newPlan",
    purchasePlanL:"purchasePlanL",
    newGasPlan:"newGasPlan",
    orders:"orders",
    errororders:"errororders",
    checkAmount:"checkAmount",
    purchasePay:"purchasePay",
    purchaseSettle:"purchaseSettle",
    orderinvoice:"orderinvoice",
    orderaccount:"orderaccount",
    orderform:"orderform",
    supplierbuget:"supplierbuget",
    paybuget:"paybuget",
    adjustPrice:"adjustPrice",
    sell: "sell",
    mySell: "mySell",
    sellList: "sellList",
    changeSupplyWay: "changeSupplyWay",
    errorSellList: "errorSellList",
    innerCheckList: "innerCheckList",
    newSellGaugeTicket: "newSellGaugeTicket",
    meterReading:"meterReading",
    sellGaugeTicketList: "sellGaugeTicketList",
    remind: "remind",
    day: "day",
    pending: "pending",
    newcontract: "newcontract",
    checkcontract: "checkcontract",
    copyContract: "copyContract",
    dailyListing: "dailyListing",
    dailyCompute: "dailyCompute",
    newDaily: "newDaily",
    imformation: "imformation",
    companyList: "companyList",
    organizetion:"organizetion",
    roleAuthorize: "roleAuthorize",
    powerSet: "powerSet",
    accountList: "accountList",
    handoverList: "handoverList",
    websiteList: "websiteList",
    gasList:"gasList",
    loadList:"loadList",
    roleList: "roleList",
    staffList: "staffList",
    myProject: "myProject",
    projectList: "projectList",
    myContract: "myContract",
    contract: "contract",
    contractMould: "contractMould",
    newsupply: "newsupply",
    adjustmentList: "adjustmentList",
    newadjustment: "newadjustment",
    purchaseContract:"purchaseContract",
    baseset: "baseset",
    tagList: "tagList",
    gasificationList: "gasificationList",
    carSet: "carSet",
    driverList: "driverList",
    carTypeList: "carTypeList",
    ETCList: "ETCList",
    ETCTradeList: "ETCTradeList",
    fuelCardList: "fuelCardList",
    fuelCardTradeList: "fuelCardTradeList",
    distanceList:"distanceList",
    otherFeeList: "otherFeeList",
    gasPriceList: "gasPriceList",
    gasUseAndPrice: "gasUseAndPrice",
    lngInOutBase: "lngInOutBase",
    oilPriceList: "oilPriceList",
    loadUnloadList: "loadUnloadList",
    familyFeeList: "familyFeeList",
    gasPriceComputer: "gasPriceComputer",
    carTransportReport: "carTransportReport",
    twoInvoiceTransportReport: "twoInvoiceTransportReport",
    transportCheckReport: "transportCheckReport",
    errorTransportList: "errorTransportList",
    transportContractList: "transportContractList",
    myTransport: "myTransport",
    taskList: "taskList",
    transportList: "transportList",
    newTransport: "newTransport",
    newTrance:"newTrance",
    transportCheckList: "transportCheckList",
    checkAmountList: "checkAmountList",
    checkMoneyList: "checkMoneyList",
    transportPay:"transportPay",
    tollList:"tollList",
    saturation:"saturation",
    compareData: "compareData",
    publishArticle: "publishArticle",
    publishArticleEditor: "publishArticleEditor",
    icon: "icon",
    builtInIcon: "builtInIcon",
    shuttleBox: "shuttleBox",
    demoShuttle: "demoShuttle",
    permissions: "permissions",
    pageControl: "pageControl",
    btnControl: "btnControl",
    table: "table",
    multiDataTable: "multiDataTable",
    filterTable: "filterTable",
    dragSort: "dragSort",
    upload: "upload",
    fileUpload: "fileUpload",
    editor: "editor",
    markdown: "markdown",
    wangeditor: "wangeditor",
    multiDirectory: "multiDirectory",
    "menu2-1": "menu2-1",
    "menu2-2": "menu2-2",
    "menu2-3": "menu2-3",
    "menu3-1": "menu3-1",
    "menu3-2": "menu3-2",
    "menu3-3": "menu3-3",
    "menu4-1": "menu4-1",
    "menu4-2": "menu4-2",
    "menu5-1": "menu5-1",
    systemSettings: "systemSettings",
    navMenu: "navMenu",
    /*贸易 start*/
    riskControl:'riskControl',
    trade:'trade',
    collectionList:'collectionList',
    tradeRuleList:'tradeRuleList',
    tradeCustomerList:'tradeCustomerList',
    myTrade:'myTrade',
    tradeContractList:'tradeContractList',
    priceConfirm:'priceConfirm',
    tradeDemand:'tradeDemand',
    tradeSale:'tradeSale',
    tradeCollection:"tradeCollection",
    tradeCheckAmount:'tradeCheckAmount',
    tradeSettle:'tradeSettle',
    tradeContract:'tradeContract',
    tradeProfit:'tradeProfit',
    profitStatistics:'profitStatistics',
    profitRule:'profitRule',
    customerRebate:'customerRebate',
    businessBx:'businessBx',
    rewardRuleList:'rewardRuleList',
    awardIssueRuleList:'awardIssueRuleList',
    staffRoleList:'staffRoleList',
    salesRewardDetailList:'salesRewardDetailList',
    otherRewardDetailList:'otherRewardDetailList',
    awardIssueDetailList:'awardIssueDetailList',

    /*贸易 end*/
    newBattlePlan:'newBattlePlan',
    statisticsPlan:'statisticsPlan',
    /*钢瓶管理 start*/
    cylinder:'cylinder',
    scanRecord:'scanRecord',
    cylinderTagList:'cylinderTagList',
    cylinderContainer:'cylinderContainer',
    cylinderList:'cylinderList',
    truckRecord:'truckRecord',
    /*钢瓶管理 end*/
    /*new 合同首頁 start*/
    contractIndex:'contractIndex',
    /*new 合同首頁 end*/

    charge:'charge',
    chargeList:'chargeList',
    checkChargeList:'checkChargeList',

    /*统计报表 start*/
    statics:'statics',
    weeklyCollectionStaticsList:'weeklyCollectionStaticsList',
    cngReport:'cngReport',
    lngReport:'lngReport',
    /*统计报表 end*/

    /*其他业务 start*/
    otherBusiness:'otherBusiness',
    circulationList:'circulationList',
    circulationAdd:'circulationAdd',
    specialProcessPurchaseList:'specialProcessPurchaseList',
    /*其他业务 end*/
    oweApplyList:'oweApplyList',
    siteVisit: "siteVisit",

    /*报销管理 start*/
    reimburse:'reimburse',
    reimburseManagement:'reimburseManagement',
    reimbursementSummary:'reimbursementSummary',
    reimbursementType:'reimbursementType',
    indexStaff:'indexStaff',
    reimbursementStatistics:'reimbursementStatistics',
    /*报销管理 end*/
    /*工资管理 start*/
    salaryManagement:"salaryManagement",
    individualIncomeTaxLevel:"individualIncomeTaxLevel",
    floatingSalaryType:"floatingSalaryType",
    socialSecurityInformation:"socialSecurityInformation",
    personnelSalaryInformation:"personnelSalaryInformation",
    floatingSalary:"floatingSalary",
    salaryDetails:"salaryDetails",
    salaryAdjustment:"salaryAdjustment",
    salarySummary:"salarySummary",
    attendanceSummary:"attendanceSummary",
    /*工资管理 end*/
    /*气款管理 start*/
    gasManagement:'gasManagement',
    gasPaymentApplication:'gasPaymentApplication',
    estimatedCost:'estimatedCost',
    /*气款管理 end*/

    /*绩效考核 start*/
    performanceAppraisal:'performanceAppraisal',
    levelConfiguration:'levelConfiguration',
    assessmentCoefficient:'assessmentCoefficient',
    assessmentItems:'assessmentItems',
    assessmentRole:'assessmentRole',
    assessmentObject:'assessmentObject',
    examinationTableMonth:'examinationTableMonth',
    examinationTableYear:'examinationTableYear',
    monthlyTaskDashboard:'monthlyTaskDashboard',
    annualTaskDashboard:'annualTaskDashboard',
    performanceStatistics:'performanceStatistics',
    assessmentDataInput:'assessmentDataInput',
    /*绩效考核 start*/
  },
  rightMenu: {
    close: "close",
    closeOther: "closeOther",
    closeAll: "closeAll"
  },
  role: {
    superAdmin: "superAdmin",
    admin: "admin",
    ordinary: "ordinary"
  },
  userDropdownMenu: {
    basicInfor: "basicInfor",
    changePassword: "changePassword",
    logout: "logout"
  },

  ...enLocale //  合并element-ui内置翻译
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js